import { LocaleActionTypes } from '../../../types/locale'
import { AppThunkAction } from '../../index'
import api from '../../../api'

export const getLocaleData = (lang: string): AppThunkAction<Promise<void>> => {
	return async dispatch => {
		try {
			const res = await api.system.getLocale(lang)

			const locale = res.data?.result || {}

			if ('langKey' in locale) {
				dispatch({
					type: LocaleActionTypes.LOCALE_GET,
					payload: {
						langData: locale.langData,
						langKey: locale.langKey,
					},
				})
			}
		} catch (e: any) {
			const error = e.message || ''
			throw new Error(error)
		}
	}
}
